import React from "react";
import './Services.scss'
import cafe from '../../../images/kaficko.svg';
import { Img } from "@randajan/jet-react/dom/img";
import { Link } from "@randajan/jet-react/dom/link";
import vozik from "./vozik.jpg";

const Services = () => {
    return (
        <section className="Services slab">
            <section className='market'>
                <h2>
                    <strong>Farmářské trhy</strong>
                    <small>Pojďme se potkat na nákupu u farmářů</small>
                </h2>
                <p>Přijďte si nakoupit čerstvou zeleninu a ovoce a vaše další oblíbené produkty od lokálních farmářů na některý z pražských Farmářských trhů. My zajistíme, že nebudete odcházet hladoví.</p>
                <p className='textHighlight places'>Pravidelně nás najdete:</p>
                <section className='scheduleBox'>
                    <p className='textHighlight'>ČT - Farmářské trhy Malostranské náměstí</p>
                    <div className="btnWrap">
                        <Link to="https://trhy.malafronta.cz/">Navštívit</Link>
                    </div>
                </section>
                <section className='scheduleBox'>
                    <p className='textHighlight'>SO - Farmářské trhy Kulaťák - Dejvice, Praha 6</p>
                    <div className="btnWrap">
                        <Link to="https://www.trhynakulataku.cz/">Navštívit</Link>
                    </div>
                </section>
                <section className='scheduleBox'>
                    <p className='textHighlight'>SO - Farmářské trhy NÁPLAVKA na Výtoni, Praha 2</p>
                    <div className="btnWrap">
                        <Link to="https://www.farmarsketrziste.cz/trh/naplavka">Navštívit</Link>
                    </div>
                </section>
            </section>
            <section className='events'>
                <h2>
                    <strong>Oslavy a akce</strong>
                    <span className='cafeHeader'>
                        <small className='subheading'>Osladíme každou vaši slavnost</small>
                        <Img src={cafe} className='cafeImg' />
                    </span>
                </h2>

                <p className='textHighlight'>V rámci Café & Palačinka je možné po dohodě uspořádat komorní rodinnou oslavu s maximální kapacitou 8-10 účastníků.</p>
            </section>
            <section className='cathering'>
                <Img className="vozik" src={vozik}/>
                <div className="content">
                    <h2>Pan Palačinka</h2>
                    <p>Zamilovali jste si náš <b>palačinkový vintage vozíček</b> a plánujete dětskou nebo tématickou oslavu? V rámci Prahy <b>dorazíme za vámi</b> a zajistíme akci s výrobou palačinek a občerstvením přímo na místě.</p>
                    <p className='pricing textHighlight'>Pronájem včetně obsluhy <span className="nowrap">3500 Kč/hod</span>. Minimální doba trvání akce 3 hod.</p>
                </div>
            </section>
        </section>
    );
};

export default Services;